"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

module.exports = function LinkStyleImpl() {
  _classCallCheck(this, LinkStyleImpl);
};